//client_serena/src/pages/ConfirmationPage.js
import React from "react";
import { Box, Heading, Text, Button, Icon, VStack } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircleIcon } from "@chakra-ui/icons";

const ConfirmationPage = () => {
  const location = useLocation();
  const { order, paymentType } = location.state || {};

  return (
    <Box minH="100vh" bgGradient="linear(to-br, green.50, white 80%)" py={10} px={2}>
      <Box maxW="500px" mx="auto" bg="white" borderRadius="2xl" boxShadow="2xl" p={{ base: 4, md: 8 }} textAlign="center">
        <VStack spacing={4}>
          <Icon as={CheckCircleIcon} boxSize={16} color="green.500" mt={2} />
          <Heading mb={2} color="green.700" fontSize="2xl" fontWeight="extrabold">
            Payment Successful!
          </Heading>
          <Text fontSize="lg" color="gray.700" mb={2}>
            Thank you for your purchase. Your order has been received and is being processed.
          </Text>

          {order && (
            <Box mb={4} p={5} borderWidth={1} borderRadius="xl" bg="gray.50" boxShadow="md" w="100%">
              <Text fontWeight="bold" color="gray.700" mb={1}>
                Order Reference: <Box as="span" color="green.700">{order.reference}</Box>
              </Text>
              <Text fontWeight="bold" color="gray.700" mb={1}>
                Total Paid: <Box as="span" color="green.700">₦{order.total ? Math.round(order.total).toLocaleString() : "N/A"}</Box>
              </Text>
              <Text fontWeight="bold" color="gray.700">
                Payment Method: <Box as="span" color="green.700">{paymentType || "Paystack"}</Box>
              </Text>
            </Box>
          )}

          <Button
            as={Link}
            to="/dashboard"
            colorScheme="green"
            size="lg"
            mb={2}
            borderRadius="xl"
            fontWeight="bold"
            boxShadow="md"
            w="100%"
            _hover={{ bg: "green.600", color: "white" }}
          >
            Go to Dashboard
          </Button>
          <Button
            as={Link}
            to="/payment-history"
            variant="outline"
            colorScheme="green"
            size="lg"
            borderRadius="xl"
            fontWeight="bold"
            boxShadow="md"
            w="100%"
            _hover={{ bg: "green.50" }}
          >
            View Payment History
          </Button>

          <Text fontSize="sm" mt={6} color="gray.500" textAlign="center">
            By completing your order, you agree to our {" "}
            <Link to="/app/privacy" style={{ color: "#319795", fontWeight: 500 }}>
              Privacy Policy
            </Link>.
          </Text>
        </VStack>
      </Box>
    </Box>
  );
};

export default ConfirmationPage;
